import { createApi } from '@reduxjs/toolkit/query/react';
import { Endpoints } from 'src/config';
import { apiHelper } from 'src/utils/apiHelper';
import { baseQuery, tagType } from 'src/utils/baseQuery';

const tags = {
  list: 'story-list',
};

const StoryApi = createApi({
  reducerPath: 'story-api',
  baseQuery: baseQuery(),
  tagTypes: [tags.list],
  endpoints: (builder) => ({
    getStory: builder.query({
      providesTags: [tagType(tags.list)],
      query: (body) => apiHelper(Endpoints.story.list, body),
    }),
    createStory: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.story.create,
        method: 'post',
        body: body,
      }),
    }),
    editStory: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.story.update,
        method: 'post',
        body: body,
      }),
    }),
    deleteStory: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.story.update,
        method: 'post',
        body,
      }),
    }),
  }),
});

export const { useGetStoryQuery, useCreateStoryMutation, useEditStoryMutation, useDeleteStoryMutation } = StoryApi;
export { StoryApi };
